import { createSelector } from '@ngrx/store';
import { ProjectModelField, ProjectModelWithRelations } from '@rappider/rappider-sdk';
import { orderBy } from 'lodash';

export const getProjectModelsWithFields = createSelector(
  state => state['projectModel']?.data,
  state => state['projectModelField']?.data,
  state => state['projectModelField']?.isLoaded,
  state => state['projectModel']?.isLoaded,
  (
    projectModels: ProjectModelWithRelations[],
    projectModelFields: ProjectModelField[],
    isProjectModelsLoaded: boolean,
    isProjectModelFieldsLoaded: boolean) => {
    if (isProjectModelFieldsLoaded && isProjectModelsLoaded) {
      return projectModels.map(projectModel => (
        {
          ...projectModel,
          fields: orderBy(projectModelFields.filter(projectModelField => projectModelField.projectModelId === projectModel.id), 'index', 'asc')
        }
      ));
    }
  }
);


/**
 * A selector factory that returns a single project model by its ID,
 * including its ordered fields.
 *
 * @param id The ID of the project model to select.
 */
export const getProjectModelWithFieldsById = (id: string) =>
  createSelector(
    state => state['projectModel']?.data,
    state => state['projectModelField']?.data,
    state => state['projectModelField']?.isLoaded,
    state => state['projectModel']?.isLoaded,
    (
      projectModels: ProjectModelWithRelations[],
      projectModelFields: ProjectModelField[],
      isProjectModelsLoaded: boolean,
      isProjectModelFieldsLoaded: boolean) => {
      if (isProjectModelFieldsLoaded && isProjectModelsLoaded) {
        const projectModel = projectModels.find(model => model.id === id);
        if (!projectModel) {
          return undefined;
        } else {
          return {
            ...projectModel,
            fields: orderBy(projectModelFields.filter(projectModelField => projectModelField.projectModelId === projectModel.id), 'index', 'asc')
          };
        }
      }
    }
  );
